export function Home() {
	return (
		<div>
			<h1>Home</h1>
			{/* Welcome message */}
			<p>
				Welcome to the the <span className="font-bold">new</span> Fireball
				dashboard.
			</p>
		</div>
	);
}
